import React, { HTMLAttributes } from 'react';
import Icon from '../../basic/icons';

interface CardMediaProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  iconCode?: any;
}

const CardMedia = ({ className, iconCode }: CardMediaProps): JSX.Element => {
  return <Icon name={iconCode} className={className} />;
};

export default CardMedia;
